import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=bfac578e&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfac578e')) {
      api.createRecord('bfac578e', component.options)
    } else {
      api.reload('bfac578e', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=bfac578e&", function () {
      api.rerender('bfac578e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ob52oKKH6kr9/JS/comp/IncreaseNumber.vue"
export default component.exports